import { css } from 'styled-components';
import _ from 'lodash';
import { colorVariables, fontVariables } from 'desktop/theme/variables';

const base = css`
  position: relative;
  margin: 0;
  font-weight: inherit;
  user-select: none;
  transition: color 135ms ease-in;

  ${(props) => css`
    color: ${_.get(colorVariables, props.color, null)};
    font-size: ${_.get(fontVariables, props.size, null) || fontVariables.fs_md};
    &:hover {
      color: ${_.get(colorVariables, props.hover, null)};
      transition: color 135ms ease-out;
    }
  `}

  ${(props) =>
    props.disable &&
    css`
      cursor: default;
      pointer-events: none;
    `}

  ${(props) =>
    props.type === 'interaction'
      ? css`
          cursor: pointer;
        `
      : css`
          text-transform: ${props.type};
        `}
`;

export default base;
